import URLS from "../constants/api";
import { get_2 } from "./api";

export const downloadBusinessAPI = async () => {
    
      const response = await get_2(URLS.DOWNLOAD_BUSINESSES);
      return response;
    };